<template>
  <vx-card title="SKU">
    <vs-button
      class="mt-2"
      color="success"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      @click="handleCreate()"
    >Create</vs-button
    >
    <br />
    <div>
      <data-table :baseUrl="this.baseUrl"></data-table>
    </div>
  </vx-card>
</template>
<script>
import DataTable from "./DataTable.vue";
export default {
  components: {
    DataTable,
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/master/master-sku-tables",
    };
  },
  methods: {
    handleCreate() {
      this.$router.push({
        name: "sku-create",
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
